import React from "react";
import { PropTypes } from "prop-types";
// Material imports
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
// Limitless imports
import { withi18n } from "../../../../customer/components";
import PortalButton from "../../buttons/portal-button/PortalButton";
const InfoDialog = ({
  t,
  headerText,
  informationText,
  onCancelClick,
  classes,
  fullWidth
}) => {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Dialog, {
    open: true,
    scroll: "paper",
    "aria-labelledby": "responsive-dialog-title",
    disablePortal: false,
    onClose: (event, reason) => reason === "backdropClick" && onCancelClick(event),
    onClick: event => event.stopPropagation(),
    maxWidth: "md",
    fullWidth: fullWidth
  }, /*#__PURE__*/React.createElement(DialogTitle, {
    id: "responsive-dialog-title"
  }, t(headerText)), /*#__PURE__*/React.createElement(DialogContent, null, /*#__PURE__*/React.createElement(DialogContentText, {
    classes: {
      root: classes.contentTextRoot
    }
  }, t(informationText))), /*#__PURE__*/React.createElement(DialogActions, null, /*#__PURE__*/React.createElement(PortalButton, {
    onClick: onCancelClick,
    autoFocus: true
  }, "Close"))));
};
export default withi18n(InfoDialog);
InfoDialog.propTypes = {
  t: PropTypes.func.isRequired,
  headerText: PropTypes.string.isRequired,
  informationText: PropTypes.string.isRequired,
  onCancelClick: PropTypes.func.isRequired,
  classes: PropTypes.object,
  fullWidth: PropTypes.bool
};
InfoDialog.defaultProps = {
  classes: {
    contentTextRoot: ""
  },
  fullWidth: false
};